const OVERRIDE_TOKEN = 'confidence-override-token';

export const store = {
  get() {
    return window.sessionStorage.getItem(OVERRIDE_TOKEN) ?? undefined;
  },
  set(token: string) {
    window.sessionStorage.setItem(OVERRIDE_TOKEN, token);
  },
  remove() {
    window.sessionStorage.removeItem(OVERRIDE_TOKEN);
  },
};
